<style lang="scss" scoped>
.check {
    position: relative;
    cursor: pointer;
    font-size: 0;
    vertical-align: middle;
    input {
        position: absolute;
        visibility: hidden;
        opacity: 0;
    }
    .label {
        vertical-align: middle;
        font-size: 12px;
    }
}
</style>

<template>
    <label class="check" @click="eventStop($event)">
        <input type="checkbox" :checked="isChecked" :disabled='isDisabled' @change="update">
        <span v-if="round">
            <i class="icons" :class="[isChecked ? 'icon-checkbox-round-checked' : 'icon-checkbox-round-uncheck']"></i>
        </span>
        <span v-else>
            <i class="icons" :class="[isChecked ? 'icon-checkbox-checked' : 'icon-checkbox-uncheck']"></i>
        </span>
        <span class="label">
            <slot></slot>
        </span>
    </label>
</template>

<script>
export default {
    name: 'radio',
    props: {
        value: [Boolean, Array, Number],
        data: [Boolean, String, Number, Object],
        round: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        callback: {
            type: Function
        },
        stop: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: ''
        }
    },
    computed: {
        isChecked() {
            if (this.value.constructor === Array) {
                // return !!~this.value.indexOf(this.data)
                return this.value.isExist(this.data)
            }
            return this.value === this.data
        },
        isDisabled() {
            return !!this.disabled
        }

    },
    methods: {
        update() {
            if (this.value.constructor === Array) {
                this.$emit('input', this.value.toggle(this.data))
            } else {
                if (this.type === 'number') {
                    this.$emit('input', +!this.value)
                } else {
                    this.$emit('input', !this.value)
                }

            }
            this.callback && this.callback()
        },
        eventStop(e) {
            this.$emit('change')
            this.stop && e.stopPropagation()
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/check/checkbox.vue